import { Segment, Table, Header } from 'semantic-ui-react';

type PayDownEligibleBalancesProps = {
  accountId: string;
  paydownEligibleBalances: PayDownEligibleBalancesResponse;
};

export default function PayDownEligibleBalances(props: PayDownEligibleBalancesProps) {
  return (
    <>
      <Segment>
        <Header as="h2">Eligible Balances</Header>
        {props.paydownEligibleBalances && (
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Total Eligible Paydown Balance</Table.HeaderCell>
                <Table.HeaderCell>Total Ineligible Paydown Balance</Table.HeaderCell>
                <Table.HeaderCell>Total Account Balance</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>{props.paydownEligibleBalances.paydownPlanEligibilityStatus}</Table.Cell>
                <Table.Cell>
                  {props.paydownEligibleBalances.totalEligiblePaydownBalance?.value}
                </Table.Cell>
                <Table.Cell>
                  {props.paydownEligibleBalances.totalIneligiblePaydownBalance?.value}
                </Table.Cell>
                <Table.Cell>
                  {props.paydownEligibleBalances.totalAccountBalance?.value}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>)}
      </Segment>
    </>
  );
}